import { AfterViewChecked, AfterViewInit, Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'ls-fieldset',
  templateUrl: './fieldset.component.html',
  styleUrl: './fieldset.component.less'
})
export class FieldsetComponent  {
  @ContentChild(TemplateRef) template?: any;
  @Input({required: true}) legend: string = ""; 

}
